import { render, staticRenderFns } from "./Introduction_h5.vue?vue&type=template&id=209b9bc4&scoped=true"
import script from "./Introduction_h5.vue?vue&type=script&lang=js"
export * from "./Introduction_h5.vue?vue&type=script&lang=js"
import style0 from "./Introduction_h5.vue?vue&type=style&index=0&id=209b9bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b9bc4",
  null
  
)

export default component.exports